import React from 'react';

const RoleTable = ({ roles, onEdit, onDelete }) => {
  return (
    <table className="table table-hover align-middle">
      <thead className="table-primary">
        <tr>
          <th>Role Name</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {roles.map((role) => (
          <tr key={role.id}>
            <td className="fw-semibold">{role.name}</td>
            <td>{role.description}</td>
            <td>
              <button
                className="btn btn-outline-primary btn-sm me-2"
                onClick={() => onEdit(role)}
              >
                <i className="bi bi-pencil"></i> Edit
              </button>
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => onDelete(role.id)}
              >
                <i className="bi bi-trash"></i> Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RoleTable;
